"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLazyPromise = exports.FetchStatus = void 0;
const axios_1 = require("axios");
const react_1 = require("react");
var FetchStatus;
(function (FetchStatus) {
    FetchStatus[FetchStatus["None"] = 0] = "None";
    FetchStatus[FetchStatus["Loading"] = 1] = "Loading";
    FetchStatus[FetchStatus["Success"] = 2] = "Success";
    FetchStatus[FetchStatus["Error"] = 3] = "Error";
})(FetchStatus || (exports.FetchStatus = FetchStatus = {}));
const useLazyPromise = (promiseFn) => {
    const [result, setResult] = (0, react_1.useState)();
    const [status, setStatus] = (0, react_1.useState)(FetchStatus.None);
    const [error, setError] = (0, react_1.useState)();
    const execute = (0, react_1.useCallback)((...params) => {
        setStatus(FetchStatus.Loading);
        return promiseFn(...params)
            .then((result) => {
            setResult(result);
            setError(undefined);
            setStatus(FetchStatus.Success);
            return result;
        })
            .catch((error) => {
            var _a, _b;
            setStatus(FetchStatus.Error);
            setResult(undefined);
            if (error instanceof axios_1.AxiosError) {
                setError(new Error((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.msg));
            }
            else {
                setError(error);
            }
        });
    }, [promiseFn]);
    const executeWithVerify = (0, react_1.useCallback)((verifyFn) => {
        setStatus(FetchStatus.Loading);
        return Promise.resolve(verifyFn())
            .then((params) => {
            return promiseFn(...params);
        })
            .then((result) => {
            setResult(result);
            setStatus(FetchStatus.Success);
            return result;
        })
            .catch((error) => {
            var _a, _b;
            setStatus(FetchStatus.Error);
            if (error instanceof axios_1.AxiosError) {
                setError(new Error((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.msg));
            }
            else {
                setError(error);
            }
        });
    }, [promiseFn]);
    return { result, status, error, execute, executeWithVerify };
};
exports.useLazyPromise = useLazyPromise;
